<template>
    <div class="nav">
        <div class="main-head">
            <div class="main-head-content">
                <div class="main-head-logo" @click="home">
                    <img src="../../assets/images/logo2.png" alt="">
                </div>
                <div class="main-head-list">
                    <div class="main-head-list-left">
                        <!-- <ul class="main-list-ul">
                            <li v-on:mouseover="handleMouseover('Item1')" v-on:mouseout="handleMouseout">
                                <a href="javascript:void(0)" v-t="'industrial_product'"></a>
                                <div class="li-child" v-show="selectedItem === 'Item1'">
                                    <div class="li-main">
                                        <div class="li-main-child li-main-child1">
                                            <h4 v-t="'four_industrial_gateway'"></h4>
                                            <ul>
                                                <li><span @click="gc111">GC111</span></li>
                                                <li><span @click="t300">T300</span></li>
                                            </ul>
                                        </div>
                                        <div class="li-main-child">
                                            <h4 v-t="'five_industrial_gateway'"></h4>
                                            <ul>
                                                <li><span @click="m55">M55</span></li>
                                            </ul>
                                        </div>
                                        <div class="li-main-child">
                                            <h4 v-t="'modular'"></h4>
                                            <ul>
                                                <li><span @click="lm321">LM321</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-on:mouseover="handleMouseover('Item2')" v-on:mouseout="handleMouseout">
                                <a href="javascript:void(0)" v-t="'Data_terminal_products'"></a>
                                <div class="li-child" v-show="selectedItem === 'Item2'">
                                    <div class="li-main">
                                        <div class="li-main-child li-main-child1">
                                            <h4>CPE</h4>
                                            <ul>
                                                <li><span @click="cpeLC111">LC111</span></li>
                                            </ul>
                                        </div>
                                        <div class="li-main-child">
                                            <h4>MIFI</h4>
                                            <ul>
                                                <li><span @click="t115">T115</span></li>
                                            </ul>
                                        </div>
                                        <div class="li-main-child">
                                            <h4>USB MODEM</h4>
                                            <ul>
                                                <li><span @click="ldw931">LDW931</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-on:mouseover="handleMouseover('Item3')" v-on:mouseout="handleMouseout">
                                <a href="javascript:void(0)" v-t="'mobile_terminal'"></a>
                                <div class="li-child" v-show="selectedItem === 'Item3'">
                                    <div class="li-main">
                                        <div class="li-main-child li-main-child1">
                                            <ul>
                                               <li><span @click="lc800">LC800</span></li>
                                            </ul>
                                        </div>
                                        <div class="li-main-child">
                                            <ul>
                                                <li><span></span></li>
                                            </ul>
                                        </div>
                                        <div class="li-main-child">
                                            <ul>
                                                <li><span></span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-on:mouseover="handleMouseover('Item4')" v-on:mouseout="handleMouseout">
                                <a href="javascript:void(0)" v-t="'contact_us'"></a>
                                <div class="li-child" v-show="selectedItem === 'Item4'">
                                    <div class="li-main">
                                        <div class="li-main-child li-main-child1">
                                            <h4>
                                                <em v-t="'Project_customization'"></em>
                                            </h4>
                                        </div>
                                        <div class="li-main-child">
                                            <h4>
                                                <em v-t="'recruitment_information'" @click="recruit"></em>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="javascript:void(0)" v-t="'Technology_team'"></a>
                            </li>
                        </ul> -->

                        <ul class="main-list-ul">
                            <li v-for="item in items" :key="item.name" v-on:mouseover="handleMouseover(item.name)" v-on:mouseout="handleMouseout" :class="{ 'active': selectedItem === item.name }">
                                <a href="javascript:void(0)" v-t="item.title"></a>
                                <div class="li-child" v-show="selectedItem === item.name">
                                    <div class="li-main">
                                        <div v-for="child in item.children" :key="child.title" class="li-main-child">
                                            <h4 v-t="child.title" @click="child.title === 'recruitment_information' ? recruit() : null"></h4>
                                            <ul>
                                                <li v-for="subItem in child.subItems" :key="subItem.name">
                                                    <span @click="subItem.action">{{ subItem.name }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="main-head-list-right">
                        <div class="search-left">
                            <input type="text" id="search" @keyup.enter="enter">
                        </div>
                        <div class="search-right" @click="Search">
                            <i class="el-icon-search"></i>
                            <span v-t="'Search'"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Nav",
        data() {
            return {
                selectedItem: null,

                items: [
                    {
                        name: 'Item1',
                        title: 'industrial_product',
                        children: [
                            {
                                title: 'four_industrial_gateway',
                                subItems: [
                                    { name: 'GC111', action: this.gc111 },
                                    { name: 'T300', action: this.t300 }
                                ]
                            },
                            {
                                title: 'five_industrial_gateway',
                                subItems: [{ name: 'M55', action: this.m55 }]
                            },
                            {
                                title: 'modular',
                                subItems: [{ name: 'LM321', action: this.lm321 }]
                            }
                        ]
                    },
                    {
                        name: 'Item2',
                        title: 'Data_terminal_products',
                        children: [
                            {
                                title: 'CPE',
                                subItems: [{ name: 'LC111', action: this.cpeLC111 }]
                            },
                            {
                                title: 'MIFI',
                                subItems: [{ name: 'T115', action: this.t115 }]
                            },
                            {
                                title: 'USB MODEM',
                                subItems: [{ name: 'LDW931', action: this.ldw931 }]
                            }
                        ]
                    },
                    {
                        name: 'Item3',
                        title: 'mobile_terminal',
                        children: [
                            {
                                title: '',
                                subItems: [{ name: 'LC800', action: this.lc800 }]
                            }
                        ]
                    },
                    {
                        name: 'Item4',
                        title: 'contact_us',
                        children: [
                            {
                                title: 'Project_customization',
                                subItems: []
                            },
                            {
                                title: 'recruitment_information',
                                subItems: []
                            }
                        ]
                    },
                    {
                        name: 'Item5',
                        title: 'Technology_team',
                        children: []
                    }
                ]
            }
        },

        methods:{
            handleMouseover(item) {
                this.selectedItem = item
            },

            handleMouseout(){
                this.selectedItem = null
            },

            home(){
                this.$router.push("/")
            },

            cpeLC111(){
                this.$router.push("/cpeLC111")
            },

            t115(){
                this.$router.push("/t115")
            },

            ldw931(){
                this.$router.push("/ldw931")
            },

            gc111(){
                this.$router.push("/gc111")
            },

            t300(){
                this.$router.push("/t300")
            },

            m55(){
                this.$router.push("/m55")
            },

            lm321(){
                this.$router.push("/lm321")
            },

            d21(){
                this.$router.push("/d21")
            },

            lc800(){
                this.$router.push("/lc800")
            },

            recruit(){
                this.$router.push("/recruit")
            },

            SearchIndexOf() {
                var search = document.getElementById("search").value.toLowerCase();
                const searchTerms = [
                    { term: "深圳米饭儿数据科技有限公司 Shenzhen MifiData Technology Co., Ltd.", route: '/' },
                    { term: "cpelC111", route: '/cpeLC111' },
                    { term: "t115", route: '/t115' },
                    { term: "ldw931", route: '/ldw931' },
                    { term: "gc111", route: '/gc111' },
                    { term: "t300", route: '/t300' },
                    { term: "m55", route: '/m55' },
                    { term: "lm321", route: '/lm321' },
                    { term: "lc800", route: '/lc800' },
                    { term: "公司资质 company Qualifications", route: '/about' },
                    { term: "合作伙伴 cooperative partner", route: '/partner' },
                    { term: "招聘信息 recruitment information", route: '/recruit' }
                ];

                if (search === "") {
                    alert(this.$t("Please_enter_keywords"));
                } else {
                    let found = false;
                    for (const { term, route } of searchTerms) {
                        if (term.toLowerCase().indexOf(search) !== -1) {
                            this.$router.push(route);
                            found = true;
                            break; 
                        }
                    }
                    if (!found) {
                        alert(this.$t("No_such_search_term"));
                    }
                }
            },

            enter(){
                this.SearchIndexOf()
            },

            Search(){
                this.SearchIndexOf()
            }
        },
    }
</script>

<style scoped>
    .nav{
        width: 100%;
        position: relative;
        border-bottom: 1px solid silver;
    }
    .main-head{
        width: 1000px;
        margin: 0 auto;
    }
    .main-head-content{
        width: 1000px;
        margin: 0;
        display: flex;
        justify-content: space-between;
    }
    .main-head-logo{
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .main-head-list{
        display: flex;
        align-items: center;
    }
    .main-head-list-left ul{
        display: flex;
    }
    .main-head-list-left ul li a{
        color: #111111;
        padding: 40px 20px;
        font-size: 15px;
        display: block;
    }
    .main-head-list-left ul li.active a {
        padding: 40px 20px 38px 20px;
        border-bottom: 2px solid #c7000b; 
    }
    .main-head-list-left ul li a:hover{
        padding: 40px 20px 38px 20px;
        border-bottom: 2px solid #c7000b;
    }
    .main-head-list-right{
        display: flex;
        align-items: center;
        margin-left: 35px;
    }
    .search-left input{
        height: 25px;
        outline: none;
    }
    .search-right{
        width: 70px;
        height: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #111111;
        color: white;
        font-size: 12px;
        cursor: pointer;
    }
    .search-right i{
        font-size: 14px;
        margin-top: 2px ;
    }
    .main-list-ul li .li-child{
        position: absolute;
        top: 101px;
        left: 0;
        width: 100%;
        height: 200px;
        background: #f8f8f8;
        z-index: 3;
    }
    .li-main{
        width: 1000px;
        height: 160px;
        margin: 0 auto;
        padding: 20px 0px;
        display: flex;
        text-align: left;
    }
    .li-main-child{
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-left: 40px;
    }
    .li-main-child1{
        margin-left: 0;
    }
    .li-main-child h4{
        color: #0e90d2;
        padding-bottom: 10px;
        border-bottom: 1px solid silver;
        cursor: pointer;
    }
    .li-main-child h4 em{
        font-style: normal;
        cursor: pointer;
    }
    .li-main-child ul{
        display: flex;
        justify-content: left;
        align-items: center;
        padding-left: 0;
    }
    .li-main-child ul li{
        padding-left: 0;
        padding-right: 20px;
    }
    .li-main-child ul li span{
        cursor: pointer;
        padding: 10px 0;
        font-size: 15px;
    }
    .li-main-child ul li span:hover{
        border-bottom: 2px solid #000;
    }
</style>